// src/components/legal/LegalNotice.jsx
//
// /mentions-legales - the legal notice required of a French website (LCEN
// art. 6). [À COMPLÉTER] marks what only the company can fill in.
import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const TODO = (label) => <Box component="span" sx={{ bgcolor: '#FFF3CD', px: 0.5 }}>[À COMPLÉTER : {label}]</Box>;

export default function LegalNotice() {
  const h2 = { mt: 4, mb: 1, fontWeight: 800 };
  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      <Typography variant="h3" component="h1" sx={{ fontWeight: 900, mb: 1 }}>Mentions légales</Typography>

      <Typography variant="h5" component="h2" sx={h2}>Éditeur</Typography>
      <Typography component="div">
        {TODO('raison sociale et forme juridique')}, au capital de {TODO('capital')}<br />
        SIRET : {TODO('SIRET')} · TVA intracommunautaire : {TODO('numéro de TVA')}<br />
        Siège : {TODO('adresse')}<br />
        Directeur de la publication : {TODO('nom')}<br />
        Contact : {TODO('e-mail de contact')}
      </Typography>

      <Typography variant="h5" component="h2" sx={h2}>Hébergeur</Typography>
      <Typography>
        Microsoft Ireland Operations Limited (Microsoft Azure), One Microsoft Place, South County Business Park,
        Leopardstown, Dublin 18, Irlande.
      </Typography>

      <Typography variant="h5" component="h2" sx={h2}>Données personnelles</Typography>
      <Typography>
        Voir la <Link component={RouterLink} to="/confidentialite">politique de confidentialité</Link>.
      </Typography>

      <Typography variant="h5" component="h2" sx={h2}>Conditions générales</Typography>
      <Typography>
        Voir les <Link component={RouterLink} to="/conditions-generales">conditions générales de vente et d'utilisation</Link>{' '}
        (établissements) et les <Link component={RouterLink} to="/conditions-utilisation">conditions d'utilisation de YummiTracker</Link>{' '}
        (application).
      </Typography>
    </Container>
  );
}
